export default __webpack_public_path__ + "static/media/art-red-poster-2.4e7f2f4b.jpg";